const htmlToPlainText = (html: string): string => {
  const withLineBreaks = html.replace(/<br\s*\/?>/gi, '\n');

  return new DOMParser().parseFromString(withLineBreaks, 'text/html').body.textContent ?? '';
};

export default htmlToPlainText;
